/**
 * Opened App Trigger Component
 *
 * Trigger: "opened the app"
 * Shows: count input + "across all sessions"
 */

import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { FormTextField } from 'src/shared/Forms/Fields/FormTextField';

import { TriggerComponentProps } from '../automationTriggers';

export const OpenedAppTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();
  const count = automation.count || 1;

  if (readOnly) {
    return (
      <span>
        {t('automations.triggers.openedAppTimes', { count })}{' '}
        {t('automations.triggers.acrossAllSessions')}
      </span>
    );
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
      <Box sx={{ maxWidth: 150 }}>
        <FormTextField
          name={`automations.${index}.count`}
          label={t('automations.triggerLabels.times')}
          type="number"
          InputProps={{ inputProps: { min: 1 } }}
        />
      </Box>
      <Typography variant="body2">
        {t('automations.triggers.acrossAllSessions')}
      </Typography>
    </Stack>
  );
};
